import axios from 'axios';
import { put, call } from 'redux-saga/effects';

// CONSTANTS
import { SUPERBUNDLE_SUBMIT_FORM, SUPERBUNDLE_GET_RESULTS } from '@/constants/api';

// UTILITY
import { getLink } from '@/utility/routes';
import { analyticsFormSubmitted } from '@/utility/analytics';
import { getIPGeoData, showErrorNotification } from '@/utility/saga';

// STORE
import { SuperbundleActions } from '@/store/actions';

const { submitSuperbundleForm, getSuperbundleResults } = SuperbundleActions;

export function* submitSuperbundleFormSaga(action) {
  yield put(submitSuperbundleForm.start());

  const { data, callback } = action.payload;
  const ipApiData = yield call(getIPGeoData, false);

  try {
    const { data: respData } = yield axios.post(SUPERBUNDLE_SUBMIT_FORM, {
      ...data,
      userIp: ipApiData?.query || '',
    });

    if (window.analytics && !data.isSmallIframeType) {
      analyticsFormSubmitted();
    }

    yield put(submitSuperbundleForm.success());

    if (callback) callback(respData.data);
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put(submitSuperbundleForm.fail());
  }
}

export function* getSuperbundleResultsSaga(action) {
  yield put(getSuperbundleResults.start());

  const { id } = action.payload;
  const url = getLink(SUPERBUNDLE_GET_RESULTS, { id });

  try {
    const { data: respData } = yield axios.get(url, {
      cache: { ignoreCache: true },
    });

    yield put(
      getSuperbundleResults.success({
        data: respData.data,
      }),
    );
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put(getSuperbundleResults.fail());
  }
}
